import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import api from "../../api/Api.js";
import { Link, redirect, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Swal from "sweetalert2";

const CategoryManage = () => {

  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10);

  // =========================
  // FETCH CATEGORY DATA
  // =========================

  useEffect(() => {
    fetchCategoryData();
  }, []);

  const fetchCategoryData = async () => {
    try {
      const res = await api.get("/adminBlog/getCategoryData");
      setCategories(res.data?.data || []);
    } catch (error) {
      toast.error("Failed to load category data");
    }
  };

  // =========================
  // DELETE CATEGORY
  // =========================

  const handleDelete = async (id) => {

    const confirm = await Swal.fire({
      title: "Delete Category?",
      text: "Do you want to delete this category?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes Delete"
    });

    if (!confirm.isConfirmed) return;

    try {

      const res = await api.delete(
        `/adminBlog/deleteCategory/${id}`
      );

      if (res.data.success) {
        Swal.fire("Deleted!", "Category deleted successfully", "success");
        fetchCategoryData();
      }

    } catch (error) {
      toast.error("Failed to delete category");
    }

  };

  // =========================
  // STATUS CHANGE
  // =========================

  const handleStatusChange = async (id, status) => {

    try {

      await api.put("/adminBlog/category-status", {
        id,
        status
      });

      toast.success("Status updated");
      fetchCategoryData();

    } catch (error) {
      toast.error("Failed to update status");
    }

  };



const handleEditCategory = (catId) => {
  navigate(`/category/edit-category/${catId}`);
};

  // =========================
  // PAGINATION
  // =========================

  const indexOfLast = currentPage * perPage;
  const indexOfFirst = indexOfLast - perPage;
  const currentItems = categories.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(categories.length / perPage);

  // =========================
  // JSX
  // =========================

  return (
    <div className="container-fluid py-3 bg-white min-vh-100">

      {/* HEADER */}
      <div className="card shadow-sm border-0 mb-4 bg-primary-subtle rounded-3">
        <div className="card-body d-flex justify-content-between">
          <h4 className="fw-bold">Manage Category</h4>

          <Link
            to={"/category/add-category"}
            className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
          >
            <ArrowLeft size={16} /> Add Category
          </Link>
        </div>
      </div>

      {/* TABLE */}
      <div className="card shadow-sm border-0">
        <div className="table-responsive">

          <table className="table table-hover table-sm align-middle mb-0">

            <thead className="bg-light">
              <tr>
                <th>Sl</th>
                <th>Category Name</th>
                <th>Slug</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>

              {currentItems.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center py-4 text-muted">
                    No Category Found
                  </td>
                </tr>
              ) : (

                currentItems.map((cat, index) => (

                  <tr key={cat.cat_id}>

                    <td>{indexOfFirst + index + 1}</td>

                    <td>{cat.name}</td>

                    <td>{cat.slug}</td>

                    {/* STATUS */}
                 <td>
 {!cat.meta_title ? (
    <span style={{color:"red",fontSize:"14px"}}>Update Category SEO Details</span>
  ) : (
    <select
      className={`form-select form-select-sm ${
        cat.status == 1 ? "text-success" : "text-danger"
      }`}
      value={cat.status}
      onChange={(e) =>
        handleStatusChange(cat.cat_id, e.target.value)
      }
    >
      <option value="1">Active</option>
      <option value="0">Inactive</option>
    </select>
  )}
</td>

                    {/* ACTION */}
                    <td>
                      <button
                        className="btn btn-sm btn-primary me-2"
                        onClick={() => handleEditCategory(cat.cat_id)}
                      >
                        <i className="fa fa-pencil"></i>
                      </button>

                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(cat.cat_id)}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </td>

                  </tr>

                ))

              )}

            </tbody>

          </table>

        </div>

        {/* PAGINATION */}
        <div className="d-flex justify-content-center mt-3">
          <ul className="pagination">

            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                Prev
              </button>
            </li>

            {Array.from({ length: totalPages }, (_, i) => (
              <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                  {i + 1}
                </button>
              </li>
            ))}

            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                Next
              </button>
            </li>

          </ul>
        </div>

      </div>

    </div>
  );
};

export default CategoryManage;